import { compose, withHandlers } from 'recompose';
import { addIntlProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { orderDashboardPath } from 'utils/paths';

export const goToDashboard = ({ history }) => () => {
  history.push(orderDashboardPath);
};

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['backToDashboardString', 'submissionFailure'],
  }),
  withHandlers({ goToDashboard }),
);
